<template>
    <v-container :class="['fare', hasFareStatus ? 'fare-status' : '']"  :style="cssVars">
        <v-row v-if="hasFareStatus || fareIndex !== 1 || isSeasonal">
            <v-col cols="12" md="6">
                <div v-if="hasFareStatus" class="py-0 fare-card-subtitle color-grey-onfly">
                    <span>{{ statusLabel }}</span>
                    <v-tooltip top max-width="320" color="info">
                        <template v-slot:activator="{ on }" >
                            <v-icon color="blue" v-on="on">mdi-help-circle-outline</v-icon>
                        </template>
                        <span>
                        {{ infoTooltipLabel }}
                    </span>
                    </v-tooltip>
                </div>
            </v-col>
            <v-col cols="12" md="6" class="d-flex justify-end">
                <v-btn v-if="fareIndex !== 1 || isSeasonal"
                       outlined
                       color="error"
                       @click="$emit('removeFare', fareIndex)"
                >
                    Excluir Essa Tarifa
                </v-btn>
            </v-col>
        </v-row>
        <v-row v-if="hasRoomFare">
            <v-col cols="12" class="d-flex justify-end pt-0">
                <v-btn
                    outlined
                    :color="active === FARE_INACTIVE ? 'success' : 'warning'"
                    :loading="statusLoading"
                    @click="onToggleStatusClick"
                >
                    {{ active === FARE_INACTIVE ? 'Reativar Essa Tarifa' : 'Inativar Essa Tarifa' }}
                </v-btn>
            </v-col>
        </v-row>

        <v-dialog v-model="showDeactivateModal" max-width="450">
            <v-card>
                <v-card-title class="text-h6">Inativar Tarifa</v-card-title>
                <v-card-text>Você tem certeza que deseja inativar essa tarifa?</v-card-text>
                <v-card-actions class="justify-end">
                    <v-btn text @click="showDeactivateModal = false">Cancelar</v-btn>
                    <v-btn color="warning" :loading="statusLoading" @click="deactivate">Confirmar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="showReactivateManualModal" max-width="450">
            <v-card>
                <v-card-title class="text-h6">Reativar Tarifa</v-card-title>
                <v-card-text>Você tem certeza que deseja reativar essa tarifa?</v-card-text>
                <v-card-actions class="justify-end">
                    <v-btn text @click="showReactivateManualModal = false">Cancelar</v-btn>
                    <v-btn color="success" :loading="statusLoading" @click="reactivate(null)">Confirmar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="showReactivatePriceRefusalModal" max-width="500">
            <v-card>
                <v-card-title class="text-h6">Reativar Tarifa</v-card-title>
                <v-card-text>
                    <p>Esta tarifa foi inativada porque o hoteleiro recusou atualizar o valor durante um cancelamento por motivo comercial.</p>
                    <p>Para reativar a tarifa, informe o novo valor da diária:</p>
                    <v-text-field
                        outlined
                        v-model="newAmount"
                        label="Novo Valor da Diária"
                        v-money="money"
                        :error-messages="newAmountError"
                    ></v-text-field>
                </v-card-text>
                <v-card-actions class="justify-end">
                    <v-btn text @click="showReactivatePriceRefusalModal = false; newAmount = 'R$ 0,00'">Cancelar</v-btn>
                    <v-btn
                        color="success"
                        :loading="statusLoading"
                        :disabled="!isNewAmountValid"
                        @click="reactivate(getOnlyNumericChars(newAmount))"
                    >Reativar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-container v-if="active === 0"
            class="ma-0 px-2 py-1 inactive" >
            <v-icon color="#FFF">mdi-alert</v-icon><span>Tarifa inativa!</span>
        </v-container>
        <v-row>
            <v-col cols="12" md="4">
                <v-checkbox
                    v-model="breakfast"
                    label="Café da Manhã"
                ></v-checkbox>
            </v-col>
            <v-col cols="12" md="4">
                <v-checkbox
                    v-model="refundable"
                    label="Reembolsável"
                ></v-checkbox>
            </v-col>
            <v-col v-if="!ownerCreationForm" cols="12" md="4">
                <v-checkbox
                    v-model="hasAgreement"
                    label="Possui acordo"
                    :disabled="!canEditAgreementRate"
                ></v-checkbox>
            </v-col>
            <v-col v-else cols="12" md="4"></v-col>
            <v-col class="mt-2" cols="12" md="4">
                <v-text-field
                    :key="fareValueKey"
                    outlined
                    v-model="value"
                    :rules="valueRules"
                    label="Valor da Diária"
                    v-money="money"
                    required
                    :disabled="(hasAgreement && !canEditAgreementRate) || (!hasAgreement && !canEditPublicRate)"
                ></v-text-field>
            </v-col>
            <v-col class="mt-2" cols="12" md="4">
                <v-menu
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    max-width="290px"
                    min-width="auto"
                    :disabled="!canEditFareExpirationDate"
                >
                    <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                            v-model="visibleExpirationDate"
                            label="Tarifa válida até"
                            outlined
                            readonly
                            :rules="visibleExpirationDateRules"
                            prepend-inner-icon="mdi-calendar"
                            v-bind="attrs"
                            v-on="on"
                        ></v-text-field>
                    </template>
                    <v-date-picker
                        v-model="expirationDate"
                        locale="pt-BR"
                        :first-day-of-week="1"
                        no-title
                    ></v-date-picker>
                </v-menu>
            </v-col>
            <v-col v-if="refundable" class="mt-2" cols="12" md="4">
                <v-text-field
                    outlined
                    v-model="daysBefore"
                    :rules="daysBeforeRules"
                    label="Antecedência do reembolso"
                    placeholder="Dias"
                    hint="Até quantos dias antes do check-in a tarifa é reembolsável"
                    persistent-hint
                ></v-text-field>
            </v-col>
            <v-col cols="12" class="mt-2" v-if="hasAgreement && !ownerCreationForm">
                <v-autocomplete
                    ref="autocomplete"
                    outlined
                    v-model="pointsOfSale"
                    :items="pointsOfSaleList"
                    :search-input.sync="searchPointsOfSale"
                    :loading="autocompleteLoading"
                    :rules="pointOfSaleRules"
                    @change="clearSearch"
                    :item-text="itemText"
                    item-value="id"
                    label="Pontos de Venda"
                    no-data-text="Nenhum resultado encontrado"
                    color="secondary"
                    placeholder="Mínimo de 3 caracteres para buscar"
                    item-color="secondary"
                    autocomplete="off"
                    cache-items
                    multiple
                    clearable
                    chips
                    small-chips
                >
                    <template #selection="{ item }">
                        <v-chip
                            v-if="item.active"
                            close
                            @click:close="deleteChip(item, pointsOfSale)"
                        >
                            {{item.id}} - {{item.name}}
                        </v-chip>
                        <v-chip
                            v-if="!item.active"
                            color="#ff5252"
                            close
                            @click:close="deleteChip(item, pointsOfSale)"
                        >
                            {{item.id}} - {{item.name}}
                        </v-chip>
                    </template>
                </v-autocomplete>
            </v-col>
            <v-col v-if="!isSeasonal" cols="12" class="mb-5">
                <div class="fare__week-days-applicability__title color-grey-onfly mb-2">Tarifa Disponível em: </div>
                <v-row no-gutters>
                    <v-col
                        v-for="day in days"
                        :key="day.key"
                        cols="6" sm="4" md="3"
                    >
                        <v-checkbox
                            v-model="daysOfWeek"
                            :label="day.label"
                            :value="day.key"
                            :disabled="isDayDisabled(day.key)"
                            hide-details
                            dense
                        ></v-checkbox>
                    </v-col>
                    <v-col cols="12" v-if="!hasSelectedAtLeastOneWeekDay" class="mt-1">
                        <span class="fare__week-days-applicability__error-message red--text">
                            <template v-if="allDaysBlocked">Somente uma tarifa {{ breakfast ? 'com' : 'sem' }} café da manhã pode estar disponível por dia no mesmo quarto.</template>
                            <template v-else>Selecione pelo menos um dia da semana</template>
                        </span>
                    </v-col>
                </v-row>
            </v-col>
            <v-col v-if="isSeasonal" cols="12" class="pt-0">
                <fare-seasonality-rules
                    ref="seasonalityRules"
                    v-model="seasonalityRules"
                    :room-id="roomId"
                />
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import FareExpirationMixin from "../../../mixins/Fares/FareExpirationMixin";
import HotelOwnerCreationMixin from "../../../mixins/HotelOwnerCreation/HotelOwnerCreationMixin";
import FareSeasonalityRules from "./FareSeasonalityRules.vue";
import PointOfSaleService from "../../../services/PointOfSaleService";

export default {
    name: "Fare",
    mixins: [FareExpirationMixin, HotelOwnerCreationMixin],
    components: {
        FareSeasonalityRules,
    },
    props: {
        fareIndex: {
            type: Number
        },
        roomFare: {
            type: Object,
            default: null
        },
        disabledDays: {
            type: Array,
            default: function () { return []; }
        },
        isSeasonal: {
            type: Boolean,
            default: false,
        },
        hostRoomId: {
            type: Number,
            default: null,
        },
    },
    inject: ['ownerCreationForm'],
    data: () => ({
        FARE_ACTIVE: 1,
        FARE_INACTIVE: 0,
        fareValueKey: 0,
        statusLoading: false,
        showDeactivateModal: false,
        showReactivateManualModal: false,
        showReactivatePriceRefusalModal: false,
        newAmount: 'R$ 0,00',
        breakfast: false,
        refundable: false,
        daysBefore: null,
        hasAgreement: false,
        seasonalityRules: [],
        pointsOfSale: [],
        searchPointsOfSale: '',
        money: {
            decimal: ',',
            thousands: '.',
            prefix: 'R$ ',
            precision: 2
        },
        value: 'R$ 0,00',
        days: [
            { key: 'monday',    label: 'Segunda-feira'  },
            { key: 'tuesday',   label: 'Terça-feira'    },
            { key: 'wednesday', label: 'Quarta-feira'   },
            { key: 'thursday',  label: 'Quinta-feira'   },
            { key: 'friday',    label: 'Sexta-feira'    },
            { key: 'saturday',  label: 'Sábado'         },
            { key: 'sunday',    label: 'Domingo'       },
        ],
        daysOfWeek: [],
        expirationDate: null,
        expirationDateMenu: false,
        active: '',
        visibleExpirationDateRules: [
            v => !!v || 'A data de validade da tarifa é obrigatória',
        ],
        valueRules: [
            v => !!v || 'O valor da tarifa é obrigatorio',
            v => v.length > 0 && parseInt(v.replace(/\D/g, '')) > 0 || 'O valor da tarifa é obrigatorio'
        ],
        daysBeforeRules: [
            v => !!v || 'A informação de até quantos dias antes do check-in a tarifa é reembolsavel, é obrigatoria.'
        ],
        pointOfSaleRules: [
            v => !!(v && v.length) || 'É obrigatório selecionar o ponto de venda referente ao acordo'
        ],
        updatedFields: {
            breakfast: false,
            refundable: false,
            daysBefore: false,
            value: false,
            hasAgreement: false,
            pointsOfSale: false,
            expirationDate: false,
            daysOfWeek: false,
        }
    }),
    created() {
        PointOfSaleService.getPointsOfSale();

        if (this.roomFare !== null) {
            this.setData();
            this.setRoomFareStatusByExpirationDate();
        } else {
            this.setDefaultExpirationDate();
        }

        var self = this;
        this.$nextTick(function () {
            self.emitFareState();
        });
    },
    methods: {
        getData() {
            return {
                "breakfast": this.breakfast,
                "refundable": this.refundable,
                "value": this.value,
                "daysBefore": this.daysBefore,
                "id": this.roomFare !== null ? this.roomFare.id : null,
                "agreement": this.hasAgreement,
                "pointsOfSale": this.hasAgreement ? this.pointsOfSale : null,
                "active": this.active === '' ? true : this.active,
                "expirationDate": this.expirationDate,
                "rules": this.getFareRules(),
            }
        },

        setData() {
            this.breakfast = this.roomFare.breakfast;
            this.refundable = this.roomFare.refundable;
            this.daysBefore = this.roomFare.days_before_checkin;
            this.value = this.roomFare.amount;
            this.expirationDate = this.roomFare.expiration_date;
            this.hasAgreement = this.roomFare.agreement;
            this.pointsOfSale = this.getPointsOfSale();
            this.active = this.roomFare.active;
            this.daysOfWeek = this.getWeekDayNamesFromFareRules();
            this.seasonalityRules = this.getSeasonalityRulesFromFare();
        },

        getSeasonalityRulesFromFare: function () {
            if (!this.roomFare || !this.roomFare.rules) { return []; }
            const applicability = this.roomFare.rules.applicability;
            if (!applicability) { return []; }
            const seasonalityRules = applicability.seasonality_rules;
            return Array.isArray(seasonalityRules) ? seasonalityRules.slice() : [];
        },

        getWeekDayNamesFromFareRules() {
            let allDayNames = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];
            let rules = this.roomFare.rules;
            if (!rules || !rules.applicability) {
                return allDayNames;
            }
            let applicability = rules.applicability;
            if (!applicability || !applicability.week_days_rule) {
                return allDayNames;
            }
            let weekDaysRule = applicability.week_days_rule;
            return allDayNames.filter(function (day) { return weekDaysRule[day]; });
        },

        getFareRules() {
            const seasonalityRulesPayload = this.seasonalityRules.map(function (r) {
                return {
                    initial_date: r.initial_date,
                    final_date: r.final_date,
                };
            });

            const applicabilityEntry = { seasonality_rules: seasonalityRulesPayload };

            if (!this.isSeasonal) {
                let dayNames = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];
                let weekDaysRule = {};
                dayNames.forEach(function (day) {
                    weekDaysRule[day] = this.daysOfWeek.includes(day);
                }, this);
                applicabilityEntry.week_days_rule = weekDaysRule;
            }

            return { applicability: [applicabilityEntry] };
        },

        getPointsOfSale() {
            let listOfPointsOfSale = [];
            this.roomFare.points_of_sale.forEach((pointOfSale) => {
                listOfPointsOfSale.push(pointOfSale.id);
            });
            return listOfPointsOfSale;
        },

        clearSearch() {
            this.searchPointsOfSale = '';
        },

        deleteChip(itemToDelete, list) {
            list.forEach((item, index) => {
                if (item === itemToDelete.id) {
                    list.splice(index, 1);
                }
            });
        },

        itemText: item => item.id + ' - ' + item.name,

        getOnlyNumericChars (value) {
            if (value === undefined || value === null || value === '') { return null; }
            return Number(value.replace(/[^\d]+/g, ''));
        },
        setRoomFareStatusByExpirationDateOrUpdateProperty () {
            if (this.hasAnyUpdatedField) {
                this.setRoomFarePendingUpdateStatus();
            } else {
                this.setRoomFareStatusByExpirationDate();
            }
        },
        setUpdatedField (fieldName, value) {
            this.updatedFields[fieldName] = !!value;
        },
        compareIfArrayElementsAreEqual (arrayOne, arrayTwo) {
            return arrayOne.every((value) => arrayTwo.includes(value));
        },
        emitFareState: function () {
            this.$emit('fare-state-changed', {
                fareKey: this.fareIndex,
                weekDays: this.daysOfWeek.slice(),
                breakfast: this.breakfast,
                hasAgreement: this.hasAgreement
            });
        },
        validateSeasonality () {
            if (!this.isSeasonal) { return true; }
            return this.$refs.seasonalityRules.validate();
        },
        onToggleStatusClick() {
            if (this.active === this.FARE_INACTIVE) {
                if (this.roomFare.inactivated_reason === 'price_refusal') {
                    this.showReactivatePriceRefusalModal = true;
                } else {
                    this.showReactivateManualModal = true;
                }
            } else {
                this.showDeactivateModal = true;
            }
        },

        async deactivate() {
            this.statusLoading = true;
            try {
                const { data } = await axios.put(`/api/fares/${this.roomFare.id}/deactivate`);
                if (data.success === false) { throw new Error(data.message); }
                this.applyInactiveState();
            } catch (e) {
                this.$root.$emit('snackbar', { message: e.message || 'Ocorreu um erro ao inativar a tarifa.', color: 'error' });
            } finally {
                this.statusLoading = false;
                this.showDeactivateModal = false;
            }
        },

        async reactivate(amountInCents) {
            this.statusLoading = true;
            try {
                const payload = amountInCents !== null ? { amount: amountInCents } : {};
                const { data } = await axios.put(`/api/fares/${this.roomFare.id}/reactivate`, payload);
                if (data.success === false) { throw new Error(data.message); }
                this.applyActiveState(amountInCents);
            } catch (e) {
                this.$root.$emit('snackbar', { message: e.message || 'Ocorreu um erro ao reativar a tarifa.', color: 'error' });
            } finally {
                this.statusLoading = false;
                this.showReactivateManualModal = false;
                this.showReactivatePriceRefusalModal = false;
                this.newAmount = 'R$ 0,00';
            }
        },

        applyInactiveState() {
            this.active = this.FARE_INACTIVE;
            this.roomFare.active = this.FARE_INACTIVE;
            this.roomFare.inactivated_reason = 'manual';
        },

        applyActiveState(amountInCents) {
            this.active = this.FARE_ACTIVE;
            this.roomFare.active = this.FARE_ACTIVE;
            this.roomFare.inactivated_reason = null;
            if (amountInCents !== null) {
                this.value = this.formatCentsToMoney(amountInCents);
                this.roomFare.amount = amountInCents;
                this.fareValueKey++;
            }
        },

        formatCentsToMoney(cents) {
            const value = cents / 100;
            return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(value).replace('\u00A0', ' ');
        },

        isDayDisabled: function (dayValue) {
            if (this.hasAgreement) {
                return false;
            }

            return this.disabledDays.indexOf(dayValue) !== -1;
        },
        toggleDay: function (dayValue) {
            var index = this.daysOfWeek.indexOf(dayValue);
            if (index === -1) {
                if (this.isDayDisabled(dayValue)) {
                    return;
                }
                this.daysOfWeek.push(dayValue);
            } else {
                this.daysOfWeek.splice(index, 1);
            }
        },
    },

    computed: {
        pointsOfSaleList() {
            return PointOfSaleService.getState().items;
        },
        autocompleteLoading() {
            return PointOfSaleService.getState().loading;
        },
        hasRoomFare () {
            return this.roomFare !== null;
        },
        hasAnyUpdatedField () {
            return Object.values(this.updatedFields).some((field) => field === true);
        },
        canEditPublicRate () {
            return this.$can('change.public-rate') || this.isHotelOwnerCreationRoute();
        },
        canEditAgreementRate () {
            return this.$can('change.agreement-rate') || this.isHotelOwnerCreationRoute();
        },
        canEditFareExpirationDate () {
            return this.$can('change.fare-expiration-date') || this.isHotelOwnerCreationRoute();
        },
        visibleExpirationDate () {
            if (this.expirationDate === null) { return null; }
            return this.formatDateTimeIntoDate(this.expirationDate);
        },
        hasSelectedAtLeastOneWeekDay () {
            if (this.isSeasonal) { return true; }
            return this.daysOfWeek.length > 0;
        },
        hasSeasonalityPeriods () {
            return !this.isSeasonal || this.seasonalityRules.length > 0;
        },
        allDaysBlocked () {
            var self = this;
            return this.days.every(function (day) {
                return self.isDayDisabled(day.key);
            });
        },
        newAmountError () {
            const amount = this.getOnlyNumericChars(this.newAmount);
            if (!amount || amount <= 0) return 'Informe um valor maior que zero.';
            if (amount === this.roomFare.amount) return 'O novo valor deve ser diferente do valor atual.';
            return '';
        },
        isNewAmountValid () {
            return this.newAmountError === '';
        },
        roomId () {
            if (this.roomFare && this.roomFare.room_id) {
                return this.roomFare.room_id;
            }
            return this.hostRoomId;
        }
    },

    watch: {
        value (val) {
            if (this.hasRoomFare) {
                this.setUpdatedField('value', this.getOnlyNumericChars(this.value) !== this.roomFare.amount);
                this.setRoomFareStatusByExpirationDateOrUpdateProperty();
            }
        },
        breakfast (val) {
            this.emitFareState();
            if (this.hasRoomFare) {
                this.setUpdatedField('breakfast', !!this.breakfast !== !!this.roomFare.breakfast);
                this.setRoomFareStatusByExpirationDateOrUpdateProperty();
            }
        },
        newAmount (val) {
            if (val && val.includes('-')) {
                this.newAmount = val.replace(/-/g, '');
            }
        },
        refundable (val) {
            if (this.hasRoomFare) {
                this.setUpdatedField('refundable', !!this.refundable !== !!this.roomFare.refundable);
                this.setRoomFareStatusByExpirationDateOrUpdateProperty();
            }
        },
        daysBefore (val) {
            if (this.hasRoomFare) {
                this.setUpdatedField('daysBefore', Number(this.daysBefore) !== this.roomFare.days_before_checkin);
                this.setRoomFareStatusByExpirationDateOrUpdateProperty();
            }
        },
        hasAgreement (val) {
            if (!val) {
                this.pointsOfSale = [];
            }
            this.emitFareState();
            if (this.hasRoomFare) {
                this.setUpdatedField('hasAgreement', !!this.hasAgreement !== !!this.roomFare.agreement);
                this.setRoomFareStatusByExpirationDateOrUpdateProperty();
            }
        },
        pointsOfSale (val) {
            if (this.hasRoomFare) {
                this.setUpdatedField(
                    'pointsOfSale',
                    !this.compareIfArrayElementsAreEqual(this.pointsOfSale, this.getPointsOfSale())
                );
                this.setRoomFareStatusByExpirationDateOrUpdateProperty();
            }
        },
        expirationDate (val) {
            if (this.hasRoomFare) {
                this.setUpdatedField(
                    'expirationDate',
                    this.formatDateTimeIntoDate(this.expirationDate) !== this.formatDateTimeIntoDate(this.roomFare.expiration_date));
                this.setRoomFareStatusByExpirationDateOrUpdateProperty();
            }
        },
        daysOfWeek: {
            handler: function (val) {
                this.emitFareState();
                if (this.hasRoomFare) {
                    var original = this.getWeekDayNamesFromFareRules();
                    this.setUpdatedField(
                        'daysOfWeek',
                        this.daysOfWeek.length !== original.length ||
                        !this.compareIfArrayElementsAreEqual(this.daysOfWeek, original)
                    );
                    this.setRoomFareStatusByExpirationDateOrUpdateProperty();
                }
            },
            deep: true
        },
        disabledDays: function (newDisabledDays) {
            if (this.hasAgreement) { return; }
            var self = this;
            newDisabledDays.forEach(function (day) {
                var index = self.daysOfWeek.indexOf(day);
                if (index !== -1) {
                    self.daysOfWeek.splice(index, 1);
                }
            });
        }
    }
}
</script>

<style lang="scss" scoped>
.fare {
    border: 1px solid rgba(0, 0, 0, .38);
    border-radius: 8px;
    margin-top: 1rem;
    margin-bottom: 1rem;
}

.fare-card-subtitle {
    font-size: 18px;
    font-weight: 500;
}

.fare-status-color {
    color: var(--fare-status-color) !important;
}

.fare.fare-status {
    border-left: 6px solid var(--fare-status-color) !important;
}

.border-bottom-status-color {
    border-bottom: 2px solid var(--fare-status-color) !important;
}

.fare .v-input--checkbox .v-label {
    margin-bottom: 0;
}

.v-alert__icon {
    margin: 0;
}

.inactive {
    max-width: fit-content;
    display: inline-block;
    background-color: #fb8c00;
    color: #FFF;
    border-radius: 4px;
}

.fare__week-days-applicability__title {
    font-size: 0.875rem;
    font-weight: 600;
}

.fare__week-days-applicability__error-message {
    padding-left: 0.25rem;
    font-size: 0.75rem;
}
</style>
